/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import style from '../../../../../../assets/styles/createQuestion.module.css';
import TinyMCE from '../../../../../atoms/QuillEditor';
import QuillEditor from '../../../../../atoms/QuillEditor';
import arrowIcon from '../../../../../../assets/images/upArrow.svg';
import MathJaxStaticRender from '../../../../../reusableComponents/MathJsxRender';

const TITA_specificRange = ({
  body,
  questionbutton,
  setbodyformultiquestion,
}: {
  body: any;
  questionbutton: number;
  // eslint-disable-next-line no-unused-vars
  setbodyformultiquestion: (body: any) => void;
}) => {
  // _______ TO SET THE RANGE  OF SPECIFIC FORMAT OF TITA _______
  const rangerAnswer = (e: any, key: any) => {
    const rangeText = [...correntAnswerTita];
    if (key === 'from') {
      rangeText[0] = e.target.value;
    } else if (key === 'to') {
      rangeText[1] = e.target.value;
    } else if (key === 'unit') {
      rangeText[2] = e.target.value;
    }

    setCorrentAnswerTita(rangeText);
  };

  // state of explanation_text and compose text
  const [questionDirection, setQuestionDirection] = useState<string | undefined>(
    body[questionbutton]?.question_direction
  );
  const [explanation_text, setExplanation_text] = useState(body[questionbutton]?.explaination_text);
  const [compose_text, setCompose_text] = useState(body[questionbutton]?.compose_question);
  const [explanation_video, setExplanation_video] = useState(body[questionbutton]?.explaination_video);
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const [lastIndex] = useState(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [randomise_answers] = useState(body[questionbutton]?.randomise_answers);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [answerFormat, setAnswerFormat] = useState(body[questionbutton]?.answer_format);
  const [videoId, setVideoId] = useState(body[questionbutton]?.video_id);
  // correct answer for TITA
  const [correntAnswerTita, setCorrentAnswerTita] = useState(body[questionbutton]?.correct_answer?.split(',') || []);
  const [questionIdentifier, setQuestionIdentifier] = useState<string | undefined>(
    body[questionbutton]?.question_short_identifier
  );

  /* ----------------Latex Preview States ---------------- */
  const [showComposePreview, setShowComposePreview] = useState(false);
  const [showQuestionDirectionPreview, setShowQuestionDirectionPreview] = useState(false);
  const [showExplanationPreview, setShowExplanationPreview] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (event.target.value === 'Select') {
      setAnswerFormat(event.target.value);
    } else {
      const answerFormat = Number(event.target.value);
      setAnswerFormat(answerFormat);
    }
  };

  useEffect(() => {
    if (body[questionbutton]?.answer_format >= 0) {
      setAnswerFormat(body[questionbutton]?.answer_format);
    }
  }, [body]);

  const AddUpdateBody = () => {
    const updatebody = [...body];
    updatebody[questionbutton] = {
      idx: questionbutton,
      question_type_id: body[questionbutton]?.question_type_id,
      question_short_identifier: questionIdentifier,
      question_direction: questionDirection,
      compose_question: compose_text,
      correct_answer: correntAnswerTita.toString(),
      last_option_idx: lastIndex,
      randomise_answers: randomise_answers,
      explaination_video: explanation_video || null,
      explaination_text: explanation_text || null,
      answer_format: answerFormat,
      task_label: null,
      video_id: videoId || null,

      // "difficulty":basicInfo.difficulty,
      // "question_type":body[questionbutton]?.question_type_id,
      // "format":basicInfo.format
    };
    setbodyformultiquestion(updatebody);
  };

  useEffect(() => {
    AddUpdateBody();
  }, [
    questionDirection,
    questionIdentifier,
    compose_text,
    correntAnswerTita,
    answerFormat,
    explanation_text,
    lastIndex,
    randomise_answers,
    explanation_video,
    videoId,
  ]);

  function convertToBase64(str: string) {
    return btoa(unescape(encodeURIComponent(str)));
  }

  function isBase64Check(str: string): boolean {
    try {
      return btoa(atob(str)) === str;
    } catch (e) {
      return false;
    }
  }

  function b64DecodeUnicode(str: string) {
    if (!isBase64Check(str)) {
      return str; // Return the original text if it's not Base64 encoded
    }

    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }
  const decode = (val?: string) => (val ? b64DecodeUnicode(val) : '');

  return (
    <>
      {/* QUESTION_CREATING_FINAL_SCREEN  */}
      <div className={style.tinymce_text}>
        {/* add explanation_text with tnymce*/}
        <div className={style.Question_Direction}>
          <p>
            Enter Question Short Identifier <b className={style.red_mendantory}>*</b>
          </p>
          <textarea
            placeholder="Enter Question Short Identifier"
            className={`${style.question_identifier} ${style.Shortquestion} ${style.nonResizable}`}
            value={questionIdentifier}
            onChange={(e) => setQuestionIdentifier(e.target.value)}
          />
        </div>

        {/* add Question Direction with tnymce*/}
        <div className={`${style.Question_Direction} ${style.QuestionDirection}`}>
          <div className={style.default_itemcenter_and_spacebetween}>
            <p>Enter Question Direction</p>
            <button
              type="button"
              className={style.convert_btn}
              onClick={() => setShowQuestionDirectionPreview((prev) => !prev)}
            >
              {showQuestionDirectionPreview ? 'Edit' : 'Convert'}
            </button>
          </div>
          <div style={{ height: 'auto', flexGrow: '1' }}>
            {!showQuestionDirectionPreview ? (
              <QuillEditor defaultValue={decode(questionDirection)} onChange={(text) => setQuestionDirection(text)} />
            ) : (
              <MathJaxStaticRender html={decode(questionDirection)} />
            )}
          </div>
        </div>

        {/* add compose_text with tnymce*/}
        <div className={style.compose_text}>
          <div className={style.compose_header_row}>
            <p>
              Compose Question <b className={style.red_mendantory}>*</b>
            </p>
            <button type="button" className={style.convert_btn} onClick={() => setShowComposePreview((prev) => !prev)}>
              {showComposePreview ? 'Edit' : 'Convert'}
            </button>
          </div>
          <div style={{ height: 'auto', flexGrow: '1' }}>
            {!showComposePreview ? (
              <QuillEditor
                defaultValue={decode(compose_text)}
                onChange={(text) => setCompose_text(convertToBase64(text))}
              />
            ) : (
              <MathJaxStaticRender html={decode(compose_text)} />
            )}
          </div>
        </div>
        {/* choose answer type*/}
        <div className={style.Fractionanswertype}>
          <p>
            Choose Answer Format <b className={style.red_mendantory}>*</b>
          </p>
          <div style={{ position: 'relative' }}>
            <select
              id="answer-format"
              data-testid="answer-format-select"
              value={answerFormat}
              onChange={handleChange}
              className={style.answerFormatSelect}
            >
              <option value="Select" disabled hidden>
                Select
              </option>
              <option value={0}>Numerical</option>
              <option value={1}>Alphabetical</option>
              <option value={2}>Alphanumeric</option>
              <option value={3}>User Keyboard</option>
            </select>
            {/* Custom Arrow Icon */}
            <img src={arrowIcon} alt="Custom Arrow" className={style.dropdownArrow} />
          </div>
        </div>
        {/* add enter-answer with tnymce*/}
        <div className={style.correctAnswer_range}>
          <p>Enter Correct Answer Range </p>
          <div className={style.range_calculate}>
            <div className={style.range}>
              <div className={style.from}>
                <label htmlFor="from-input">From</label>
                <br />
                <input
                  id="from-input"
                  type="number"
                  className={style.range_input}
                  value={correntAnswerTita[0]}
                  onChange={(e) => rangerAnswer(e, 'from')}
                />
              </div>

              <div className={style.to}>
                <label htmlFor="to-input">To</label>
                <br />
                <input
                  id="to-input"
                  type="number"
                  className={style.range_input}
                  value={correntAnswerTita[1]}
                  onChange={(e) => rangerAnswer(e, 'to')}
                />
              </div>
            </div>
            <div className={style.rangetext}>
              <label htmlFor="answer-unit">Answer Unit</label>
              <br />
              <input
                id="answer-unit"
                type="text"
                className={style.range_input}
                value={correntAnswerTita[2]}
                onChange={(e) => rangerAnswer(e, 'unit')}
              />
            </div>
          </div>
        </div>

        {/* explanation line  */}
        <div className={style.explanation_line}>
          <hr className={style.line} />
        </div>

        {/* add explanation_video*/}
        <div className={style.explanation_text}>
          <p>
            Add Explanation Video <b className={style.red_mendantory}>*</b>
          </p>
          <div className={style.explanation_video}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.17188 14.8287L14.8287 9.17188"
                stroke="#272727"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.05063 11.293L5.63642 12.7072C4.07432 14.2693 4.07432 16.8019 5.63642 18.364C7.19851 19.9261 9.73117 19.9261 11.2933 18.364L12.7075 16.9498"
                stroke="#272727"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.293 7.05063L12.7072 5.63642C14.2693 4.07432 16.8019 4.07432 18.364 5.63642C19.9261 7.19851 19.9261 9.73117 18.364 11.2933L16.9498 12.7075"
                stroke="#272727"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              type="text"
              value={explanation_video}
              placeholder="Attach video Video Link"
              onChange={(e) => setExplanation_video(e.target.value)}
            />
          </div>
        </div>

        {/* add explanation_text with tnymce*/}
        <div className={style.explanation_text}>
          <div className={style.default_itemcenter_and_spacebetween}>
            <p>Add Explanation Text</p>
            <button type="button" className={style.convert_btn} onClick={() => setShowExplanationPreview((p) => !p)}>
              {showExplanationPreview ? 'Edit' : 'Convert'}
            </button>
          </div>
          <div style={{ height: 'auto', flexGrow: '1' }}>
            {!showExplanationPreview ? (
              <QuillEditor
                defaultValue={decode(explanation_text)}
                onChange={(text) => setExplanation_text(convertToBase64(text))}
              />
            ) : (
              <MathJaxStaticRender html={decode(explanation_text)} />
            )}
          </div>
        </div>
        <div className={style.explanation_text}>
          <p>Video ID</p>
          <div className={style.explanation_video}>
            <input
              type="text"
              value={videoId}
              placeholder="Video Cipher ID"
              onChange={(e) => setVideoId(e.target.value)}
            />
          </div>
        </div>
      </div>
      {/* QUESTION_CREATING_FINAL_SCREEN  */}
    </>
  );
};

export default TITA_specificRange;
